import React, { useState } from "react";
import Menu from "../Menu";

const Send = () => {
  const [merchantName, setMerchantName] = useState("M4");
  const [key, setKey] = useState("key4");
  const [posName, setPosName] = useState("7");
  const [msg, setMsg] = useState("Test connection");
  const [allMsg, setAllMsg] = useState("");

  return (
    <>
      <Menu /> {/* Sidebar menu included */}

      <div className="content-wrapper" style={{ padding: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {/* Form */}
          {/* WebSocket Connection Test Form */}
          <div
            style={{
              backgroundColor: "var(--surface)",
              padding: "2rem",
              borderRadius: "8px",
              width: "48%", // Adjusted to take up 48% of the width
            }}
          >
            <h4 style={{ color: "var(--text)" }}>WebSocket Connection Test</h4>

            <div className="form-group">
              <label style={{ color: "var(--text)" }}>Merchant Name</label>
              <input
                type="text"
                className="form-control"
                id="merchantName"
                value={merchantName}
                onChange={(e) => setMerchantName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label style={{ color: "var(--text)" }}>Key</label>
              <input
                type="text"
                className="form-control"
                id="key"
                value={key}
                onChange={(e) => setKey(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label style={{ color: "var(--text)" }}>POS Name</label>
              <input
                type="text"
                className="form-control"
                id="posName"
                value={posName}
                onChange={(e) => setPosName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label style={{ color: "var(--text)" }}>Message</label>
              <input
                type="text"
                className="form-control"
                id="msg"
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              <button className="btn btn-primary">
                Login
              </button>
              <button className="btn btn-success">
                Get Clients Map
              </button>
            </div>
          </div>

          {/* Message Log Box */}
          <div
            style={{
              backgroundColor: "var(--surface)",
              padding: "2rem",
              borderRadius: "8px",
              width: "48%", // Adjusted to take up 48% of the width
            }}
          >
            <h4 style={{ color: "var(--text)" }}>Message Log</h4>
            <ul style={{ maxHeight: "400px", overflowY: "scroll", color: "var(--text)" }}>
              <li style={{ color: "var(--text)" }}>
                <strong style={{ color: "var(--text)" }}>Status:</strong>{" "}
                <pre style={{ color: "var(--text)" }}>WebSocket functionality has been removed</pre>
              </li>
            </ul>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-12">
                <div className="form-group">
                  <label style={{ color: "var(--text)" }}>Message to All:</label>
                  <input
                    type="text"
                    className="form-control"
                    id="allMsg"
                    value={allMsg}
                    onChange={(e) => setAllMsg(e.target.value)}
                  />
                </div>
                <button
                  className="btn btn-warning"
                  style={{ width: "100%" }}
                >
                  Send to All
                </button>
              </div>
            </div>

            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-12">
                <div className="card">
                  <div className="card-header" style={{ backgroundColor: 'var(--info)', color: 'var(--text)' }}>
                    <h5 style={{ color: 'var(--text)', margin: 0 }}>Connected Clients</h5>
                  </div>

                  <div className="card-body table-responsive p-0">
                    <table className="table table-hover text-nowrap">
                      <thead>
                        <tr>
                          <th>Key</th>
                          <th>Message</th>
                          <th>Send</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="3" style={{ textAlign: "center", color: "var(--text)" }}>
                            WebSocket functionality has been disabled
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Send;
